<h2 mat-dialog-title>Manage Phone Numbers</h2>

<mat-dialog-content>
  <ng-container *ngIf="!isLoading; else loadingSpinner">
    <form [formGroup]="phoneForm">
      <mat-form-field>
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phoneNumber" placeholder="Enter phone number" maxlength="12">
        <mat-error *ngIf="phoneForm.get('phoneNumber').invalid">Invalid phone number</mat-error>
      </mat-form-field>
      <button mat-button (click)="addPhoneNumber()" [disabled]="phoneForm.invalid">Add</button>
    </form>

    <ul>
      <li *ngFor="let phone of phoneNumbers;">
        {{phone.phone_number}}
        <button mat-icon-button (click)="removePhoneNumber(phone.id)" type="button">
          <mat-icon>remove_circle</mat-icon>
        </button>
      </li>
    </ul>
  </ng-container>

  <ng-template #loadingSpinner>
    <div class="spinner-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="closeDialog()" [disabled]="isLoading">Done</button>
</mat-dialog-actions>
